export enum OverlayClasses {
  Block = 'se-overlay',
  Adding = 'se-overlay--adding',
  Removing = 'se-overlay--removing',
  FreezeBody = 'has-open-se-overlay'
}
